import { Box, Tooltip } from "@mui/material";
import { explanatoryNote, reportForm } from "./Report";

type ReportLegendProps = {
  reportForm: reportForm;
  legend: explanatoryNote[];
};

export const ReportLegend: React.FC<ReportLegendProps> = ({
  reportForm,
  legend,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mt: 1.5 }}>
      凡例：
      {legend.map((l, index) => (
        <Box
          key={`${l.areaId}-${l.areaName}-${index}`}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Tooltip
            title={
              <span>
                シリアルNo：{l.areaId} <br />
                エリア名：{l.areaName}
              </span>
            }
          >
            <Box
              sx={{
                backgroundColor: l.areaColor,
                width: "20px",
                height: "20px",
              }}
            />
          </Tooltip>
          <Box
            sx={{
              ml: 1,
              display: { xs: "none", lg: "block" },
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {reportForm.unit === "1" ? l.areaId : l.areaName}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
